import React from "react";
import { HashLink } from "react-router-hash-link";
import {
  Navbar,
  Typography,
  IconButton,
  Collapse,
} from "@material-tailwind/react";
import { useDispatch, useSelector } from "react-redux";

import img1 from "../../assets/teacher.png";
import img2 from "../../assets/student.png";
import img6 from "../../assets/alumni.png";
import img7 from "../../assets/department.png";
import homeIcon from "../../assets/home.png";
import dtulogo from "../../assets/dtulogo.png";
import portalimg from "../../assets/portal.svg";
import adminImg from "../../assets/admin.png";

import { logout } from "../../redux/reducers/AuthSlice";
import axios from "axios";
import { setRole } from "../../redux/reducers/UserSlice";
import { useNavigate } from "react-router-dom";

export default function StickyNavbar() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { role } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  const closeMobileNav = () => {
    setOpenNav(!openNav);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      let logoutUrl = `${process.env.REACT_APP_BACKEND_URL}/ece/${role}/logout`;

      let response;
      response = await axios.post(logoutUrl, {
        withCredentials: true,
      });

      if (response.status === 200) {
        dispatch(logout());
        dispatch(setRole(null));
        navigate("/login");
      }
    } catch (error) {
      console.error("Logout error:", error.message);
      dispatch(logout());
      dispatch(setRole(null));
      navigate("/login");
    }
  };

  const navList = (
    <ul className="mt-2 mb-4 flex flex-col gap-4 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-8">
      {!isAuthenticated && (
        <>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={homeIcon} alt="home" className="h-5 w-5 mr-2" />
              Home
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/login?role=student"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={img2} alt="student" className="h-5 w-5 mr-2" />
              Student
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/login?role=faculty"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={img1} alt="faculty" className="h-5 w-5 mr-2" />
              Faculty
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/login?role=alumni"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={img6} alt="alumni" className="h-5 w-5 mr-2" />
              Alumni
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/login?role=department"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={img7} alt="department" className="h-5 w-5 mr-2" />
              HOD Office
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to="/login?role=admin"
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={adminImg} alt="admin" className="h-5 w-5 mr-2" />
              Admin
            </HashLink>
          </Typography>
        </>
      )}

      {isAuthenticated && (
        <>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <HashLink
              to={`/${role}`}
              className="flex items-center text-gray-800 hover:text-[#800000] transition-colors"
            >
              <img src={portalimg} alt="portal" className="h-5 w-5 mr-2" />
              My Portal
            </HashLink>
          </Typography>
          <Typography as="li" variant="small" className="p-1 font-medium">
            <button
              onClick={handleLogout}
              className="w-full rounded-lg bg-[#800000] py-2 px-6 text-white font-semibold hover:bg-[#a10000] transition-colors shadow-md hover:shadow-lg"
            >
              Logout
            </button>
          </Typography>
        </>
      )}
    </ul>
  );

  return (
    <div className="fixed w-full top-0 z-50">
      <Navbar className="sticky top-0 rounded-none px-6 py-3 lg:px-8 lg:py-4 border-none bg-white shadow-md">
        <div className="flex items-center justify-between text-blue-gray-900">
          <div className="flex items-center">
            <img src={dtulogo} alt="dtulogo" className="h-12 w-auto" />
            <Typography
              as="div"
              className="ml-3 text-lg font-bold text-[#800000] hidden sm:block"
            >
              Delhi Technological University
            </Typography>
          </div>

          <div className="flex items-center gap-4">
            <div className="mr-4 hidden lg:block">{navList}</div>
            <IconButton
              variant="text"
              className="ml-auto h-8 w-8 text-[#800000] hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenNav(!openNav)}
            >
              {openNav ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </IconButton>
          </div>
        </div>

        <Collapse
          open={openNav}
          className="bg-white lg:hidden shadow-inner"
          onClick={closeMobileNav}
        >
          {navList}
        </Collapse>
      </Navbar>
    </div>
  );
}
